module.exports = __webpack_public_path__ + "img/interrogacion.505571aa.svg";